/* oxlint-disable react/no-danger */
import * as React from 'react';
import * as styles from './Description.css';

interface IDescriptionProps {
  /** HTML описания ЖК. Уже санитизирован и очищен от <h3> на входе данных в `sanitizeOffersData`. */
  description: string;
}

export function Description({ description }: IDescriptionProps) {
  if (!description) {
    return null;
  }

  return (
    <div className={styles['container']} data-testid="description" dangerouslySetInnerHTML={{ __html: description }} />
  );
}
